import {action, computed, observable} from 'mobx';

export default class {
  accountTypes = [
    { label: 'Individual', value: 'IN', copy: 'an individual' },
    { label: 'Company', value: 'CO', copy: 'a company' },
    { label: 'School', value: 'SC', copy: 'a school' },
    { label: 'Faith-based Group', value: 'FB', copy: 'a faith-based group' },
    { label: 'Foundation', value: 'FD', copy: 'a foundation' },
  ];
  otherAccountTypes = [
    { value: 'OT', copy: 'an individual' },
  ];

  accountTypeInfo = () => this.accountTypes.concat(this.otherAccountTypes).find(
    item => (item.value == this.accountType)
  )

  @action setAccountType = value => this.accountType = value

  @computed get isIndividual () { return this.accountType.startsWith('I'); }
  @computed get accountTypeLabel () { return this.isIndividual ? '' : `${this.accountTypeInfo().label} `; }
  @computed get accountTypeCopy () { return this.accountTypeInfo().copy; }
  @computed get accountTypeNamePlaceholder () { return this.isIndividual ? 'First ' : `${this.accountTypeInfo().label} `; }

  @observable accountType = 'IN';
}
